'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _itemDetail = require('./mock/itemDetail');

var _itemDetail2 = require('./remote/itemDetail');

var ItemDetail = {
    fetchItemDetailsByIds: function fetchItemDetailsByIds(params) {
        return __MOCK__ ? _itemDetail.ItemDetailMock.fetchItemDetailsByIds(params) : _itemDetail2.ItemDetailRemote.fetchItemDetailsByIds(params);
    }
};

exports.default = ItemDetail;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/itemDetail.js
// module id = /L+n
// module chunks = 57